// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { CustomEvent } from "../../../Utils/CustomEvents.js";
import { ControlsUtils } from "../../UtilsClasses/ControlsUtils.js";
import { TerceraQuickTreeTemplate } from "../../../templates.js";
import { Control } from "../Control.js";
import { QuickTree } from "./QuickTree.js";
import { KeyEventProcessor } from "../../../Commons/KeyEventProcessor.js";

export let TerceraQuickTree = Control.extend({
    template: TerceraQuickTreeTemplate,
    data: function ()
    {
        return {
            myId: 0,
            boldRootNode: false
        };
    },
    quickTree: null
});

TerceraQuickTree.prototype.getType = function () { return 'TerceraQuickTree' };

TerceraQuickTree.prototype.oninit = function ()
{
    TerceraQuickTree.uniqueId++;
    this.set({ myId: TerceraQuickTree.uniqueId });

    var keyProc = KeyEventProcessor;
    keyProc.OnKeyDown.Subscribe(this.onGlobalKeyDown, this);
    keyProc.OnKeyUp.Subscribe(this.onGlobalKeyUp, this);

    this.GlobalKeyDownHandled = new CustomEvent();
};

TerceraQuickTree.prototype.onrender = function ()
{
    var canvas = document.getElementById('tree_' + TerceraQuickTree.uniqueId);
    var ctx = canvas.getContext('2d');
    this.quickTree = new QuickTree(ctx);
    this.quickTree.boldRootNode = this.get('boldRootNode');
    this.quickTree.isMultiSelect = false;
    this.quickTree.SelectionChanged.Subscribe(this.onSelectionChanged, this);

    this.quickTree.EnterPressed.Subscribe(this.onEnterPressed, this);

    this.observe('width', function (newValue, oldValue, keypath)
    {
        this.quickTree.width = newValue;
        this.quickTree.onResize();
    }, { defer: true });
    this.observe('height', function (newValue, oldValue, keypath)
    {
        this.quickTree.height = newValue;
        this.quickTree.onResize();
    }, { defer: true });
};

TerceraQuickTree.prototype.onEnterPressed = function ()
{
    this.fire(TerceraQuickTree.Events.EnterPress);
};

TerceraQuickTree.prototype.onSelectionChanged = function ()
{
    this.fire(TerceraQuickTree.Events.Selection);
};

TerceraQuickTree.prototype.onMouseDown = function (event)
{
    Control.prototype.onMouseDown.call(this, event);
    this.quickTree.onMouseDown(event.original);
    ControlsUtils.Capture.SetCapture(this, event.original);

    this.fire(TerceraQuickTree.Events.AfterMouseDown, event);
};

TerceraQuickTree.prototype.onMouseMove = function (event)
{
    if (this.captured && event.original)
        return;
    Control.prototype.onMouseMove.call(this, event);
    this.quickTree.onMouseMove(event.original || event);
};

TerceraQuickTree.prototype.onMouseUp = function (event)
{
    if (this.captured && event.original)
        return;
    Control.prototype.onMouseUp.call(this, event);
    this.quickTree.onMouseUp(event.original || event);
};

TerceraQuickTree.prototype.onMouseWheel = function (event)
{
    Control.prototype.onMouseWheel.call(this, event);
    this.quickTree.onMouseWheel(event);
};

TerceraQuickTree.prototype.onDoubleClick = function (event)
{
    //if (this.quickTree.isMultiSelect)   //  https://tp.traderevolution.com/entity/84756  (2nd issue)
    //  return;
    Control.prototype.onDoubleClick.call(this, event);
    var res = this.quickTree.onDoubleClick(event.original);
    if (res)
        this.fire(TerceraQuickTree.Events.DoubleClick, this);
};

TerceraQuickTree.prototype.onGlobalKeyDown = function ()
{
    var container = this.get('parentContainerControl');
    if (container && container.get('focused') || this.get('focused'))
    {
        this.quickTree.onKeyDown();
        this.GlobalKeyDownHandled.Raise();
    }
};

TerceraQuickTree.prototype.onGlobalKeyUp = function ()
{
    var container = this.get('parentContainerControl');
    if (container && container.get('focused') || this.get('focused'))
        this.quickTree.onKeyUp();
};

TerceraQuickTree.prototype.onteardown = function ()
{
    var keyProc = KeyEventProcessor;
    keyProc.OnKeyDown.UnSubscribe(this.onGlobalKeyDown, this);
    keyProc.OnKeyUp.UnSubscribe(this.onGlobalKeyUp, this);
};

TerceraQuickTree.prototype.setIsMultiSelect = function (isMultiSelect)
{
    this.quickTree.isMultiSelect = isMultiSelect;
};

TerceraQuickTree.prototype.themeChange = function ()
{
    if (this.quickTree)
        this.quickTree.themeChange();
};

TerceraQuickTree.Events =
{
    EnterPress: 'EnterPress',
    DoubleClick: 'DoubleClick',
    Selection: 'selection',
    AfterMouseDown: 'afterMouseDown'
};
Object.keys(TerceraQuickTree.Events);

TerceraQuickTree.uniqueId = 0;